<template>
  <div class="el-core__header__left" v-if="account">
    <div class="emd-control" :class="[ {[`_status_${status.key}`]: status}, {'_open': showAccountList}]" ref="appContext" v-click-outside="clickedOutside">
      <div class="emd-control__wrapper">
        <span class="emd-control__status" v-if="status">{{status.value}}</span>
        <div class="emd-control__icon">
          <i class="uil uil-store"></i>
        </div>
        <div class="emd-control__text">
          <a :href="urlCompany" :title="merchant.name" target="_blank" rel="noopener noreferrer" class="emd-control__text__item">{{merchant.name}}</a>
          <h2 class="emd-control__text__item">{{accountName}}</h2>
        </div>
        <emd-tippy class="_no-wrap" id="account" :type="'ghost'" :position="'left'" :content="$t('tooltip.account')" >
          <button class="emd-action-button _has-tooltip _type_ghost" @click="toggleAccountList">
            <i class="emd-action-button__icon uil uil-exchange"></i>
          </button>
        </emd-tippy>
      </div>
      <div class="emd-control__dropdown">
        <app-context-select v-if="showAccountList" />
      </div>
    </div>
    <div class="eu-ml_4 eu-display_none eu-display_block_md">
      <div class="emd-logo-custom">
        <logo-stone-rebrand class="logo-pgm" />
      </div>
    </div>
  </div>
</template>

<i18n>
{
  "pt-BR": {
    "tooltip": {
      "account": "Selecionar Conta"
    },
    "status": {
      "test": "Teste",
      "inactive": "Inativo",
      "blocked": "Bloqueado",
      "active": "Ativo"
    }
  },
  "en-US": {
    "tooltip": {
      "account": "Select Account"
    },
    "status": {
      "test": "Test",
      "inactive": "Inactive",
      "blocked": "Blocked",
      "active": "Active"
    }
  }
}
</i18n>

<script>
import { EmdTippy } from 'emerald-vue/src/components'
import AppContextSelect from '@/components/project/ContextSelect/AppContextSelect'
import LogoStoneRebrand from '@/components/emerald/atoms/LogoStoneRebrand.vue'
export default {
  name: 'AppCoreHeaderLeft',
  components: {
    EmdTippy,
    AppContextSelect,
    LogoStoneRebrand
  },
  data () {
    return {
      showAccountList: false
    }
  },
  computed: {
    merchant () {
      return this.$store.getters.merchantData
    },
    account () {
      return this.$store.getters.accountData
    },
    status () {
      if (this.account === null) return false
      if (this.account.account_type.key === 'test') {
        return { key: 'test', value: this.$t('status.test') }
      }
      return this.statusSerializer(this.statusAccount)
    },
    statusAccount () {
      if (this.merchantBlocked) return 'blocked'
      const getterStatusAccount = this.account.status

      return getterStatusAccount ? getterStatusAccount.key || getterStatusAccount : ''
    },
    merchantBlocked () {
      return this.$store.getters.isDelinquent
    },
    accountName () {
      return !this.isTestAccount ? this.account.name : this.account.master_account_name
    },
    urlCompany () {
      return `${process.env.VUE_APP_COMPANY_URL}/${this.$route.params.merchant_id}`
    }
  },
  methods: {
    toggleAccountList () {
      this.showAccountList = !this.showAccountList
    },
    statusSerializer (statusName) {
      return {
        key: statusName === 'blocked' ? 'inactive' : statusName,
        value: this.$t(`status.${[statusName]}`)
      }
    },
    clickedOutside (e) {
      if (!this.$refs.appContext.contains(e.target) && this.showAccountList) {
        this.toggleAccountList()
      }
    }
  }
}
</script>

<style scoped>
.logo-pgm { width: 120px }
</style>
